<template>
	<div>
		<div class="row text-end">
			<help helpId="step3_help" class="float-end" title="Kísérők adatai" text="Minden Szobába minimum egy fizető vendéget kell hozzáadnia, ha nem ír be nevet az azt jelenti azon a helyen nincs vendég"></help>
		</div>
		<div class="row">
			<Loading v-if="loading"></Loading>
			<form @submit.prevent="validate" v-else>
				<Loading v-if="!rooms"></Loading>
				<div v-else class="border border-blue" v-for="(room,id) in rooms" :key="id">
					<div class="table-responsive">
						<table class="table">
							<thead>
								<tr>
									<th class="bg-blue text-center text-white">{{room.name}}</th>
									<th>Név</th>
									<th>Születési dátum</th>
									<th>Kedvezmény</th>
								</tr>
								<tr v-for="(user_row,id) in room.users" :key="id">
									<td>{{++id}}</td>
									<td><input type="text" class="form-control" v-model="user_row.name"></td>
									<td><input type="date" class="form-control" :min="min_birth_date" :max="max_birth_date" :required="user_row.name" v-model="user_row.date_of_birth"></td>
									<td>
										<Loading mini v-if="!guest_categories"></Loading>
										<select v-else class="form-select" :required="user_row.name != null && user_row.name.length != 0" v-model="user_row.guest_category_id" @change="$forceUpdate(user_row)">
											<option :value="null">Válassz kedvezmény kategóriát!</option>
											<option v-for="(guest_category,id) in filtered_guest_categories" :key="id" :value="guest_category.id">{{guest_category.name}}</option>
										</select>
									</td>
								</tr>
							</thead>
						</table>
					</div>
				</div>
				<button class="d-none" type="submit" ref="submitter"></button>
			</form>
		</div>
	</div>
</template>

<script>
import Setting from '../../apis/Setting';
import Confirmation from '../../apis/Confirmation';
import moment from 'moment';
export default {
  data(){
		return {
			rooms:null,
			guest_categories:null,
			loading:true,
			min_birth_date:moment().subtract(120, 'years').format('YYYY-MM-DD'),
			forty_years_ago:moment().subtract(40, 'years').format('YYYY-MM-DD'),
			max_birth_date:moment().format('YYYY-MM-DD'),
	}},
	computed:{
		selected_rooms(){
			return this.$store.state.selected_rooms;
		},
		user(){
			return this.$store.state.wizard_user;
		},
		logged_in_user(){
			return this.$store.state.user;
		},
		rooms_to_emit(){
			return this.rooms.map(r => ({
				id: r.id,
				users: r.users.filter(g => g.name)
			}))
		},
		filtered_guest_categories(){
			if(this.user && this.guest_categories){
				if(this.user.is_member == 1){
					return this.guest_categories
				}else{
					return this.guest_categories.filter(g => g.is_member == this.user.is_member)
				}
			}else{
				return []; 
			}
		}
	},
	watch:{
		selected_rooms(val,oldVal){
			if(!oldVal || val != oldVal){
				this.loading = true;
				this.rooms = JSON.parse(JSON.stringify(val));
				if(this.rooms){
					this.rooms.forEach(r => {
						r.users.forEach(u => {
							u.date_of_birth = this.forty_years_ago;
						})
					});
					if(this.user){
						this.rooms[0].users[0] = {
							name:this.user ? this.user.name : null,
							guest_category_id:this.user.is_member ? 1 : 5,
							date_of_birth:this.user.details.birth_date ? this.user.details.birth_date : this.forty_years_ago,
						}
					}else{
						this.rooms[0].users[0] = {
							name:null,
							guest_category_id:5,
							date_of_birth:this.forty_years_ago
						}
					}
				}
				this.loading = false;
			}
		}
	},
	created(){
		Setting.guestCategories()
		.then(response => {
			this.guest_categories = response.data
		})
	},
  methods: {
		diffInYears(date){
			return moment(new Date()).diff(moment(date), 'years')
		},
    validate() {
			if(this.rooms_to_emit.filter(r => r.users.length == 0).length != 0){
				Confirmation.swalErrorMessage('minden szobába kell minimum 1 ember')
			/* 2024.02.23. Hédi kérésére átalakítva úgy, hogy admintól ne kérje */
			}else if(this.logged_in_user && this.logged_in_user.role_id == 10 && this.rooms_to_emit.filter(r => r.users.filter(u => this.diffInYears(u.date_of_birth) >= 18).length == 0).length != 0){
				Confirmation.swalErrorMessage('minden szobába kell minimum 1 18 éven felüli')
			}else if(this.rooms_to_emit.filter(r => r.users.filter(u => ((this.diffInYears(u.date_of_birth) > 18 || this.diffInYears(u.date_of_birth) < 2) && [4,7].includes(u.guest_category_id))).length != 0).length != 0){
				Confirmation.swalErrorMessage('csak 2-18 évesekre alkalmazható a 2-18 éves kedvezmény')
			}else if(this.rooms_to_emit.filter(r => r.users.filter(u => (this.diffInYears(u.date_of_birth) > 2 && [3,6].includes(u.guest_category_id))).length != 0).length != 0){
				Confirmation.swalErrorMessage('csak 0-2 évesekre alkalmazható a 0-2 éves kedvezmény')
			}else{
				//console.log(this.rooms_to_emit,this.rooms);
				this.$store.commit('updateFilledRooms',this.rooms);
				this.$emit('validated',{rooms: this.rooms_to_emit});
			}
    },
		submitForm(){
			this.$refs.submitter.click();
		},
		restart(){
			this.rooms = null;
		}
  }

}
</script>
